import * as tConst from "../Common/Constants";
import { Ticket } from "../services/Ticket";
import * as ticketConst from "../services/Ticket";

export interface TicketItem {
  fields: Record<string, any>;
  Project?: string;
  Color?: string;
  comment?: string;
  planningPri?: number;
  Assignee?: string;
  Initiative?: string;
  Guestimate?: any;
  Teams?: string[];
  GroupBy?: string;
  Length?: number;
  [key: string]: any;
}

export interface LabelValue {
  label: string;
  value: string;
}


export function prepareTicket(
  item: any,
  GroupTitle: string = "",
  Color: string = "",
  AdditionalPlanningPriority: number = 0
): Ticket {

  const _ticket = new Ticket(item);


  return _ticket;
}

export function prepareTickets(
  items: TicketItem[],
  setAssigneeList: (list: LabelValue[]) => void,
  setInitiativeList: (list: LabelValue[]) => void
): { _assigneeList: LabelValue[]; _initiaitveList: LabelValue[] } {
  const _assigneeList: LabelValue[] = items
    .map((item) => item.Assignee as string)
    .filter((value, index, self) => self.indexOf(value) === index)
    .sort((a, b) => a.localeCompare(b))
    .map((item) => ({ label: item, value: item }));
  setAssigneeList(_assigneeList);

  const _initiaitveList2 = items.sort((a, b) => (a.planningPri ?? 0) - (b.planningPri ?? 0));
  const _initiaitveList3 = _initiaitveList2.map((item) => ({ Initiative: item.Initiative, planningPri: item.planningPri }));
  const _initiaitveList4 = _initiaitveList3.filter(
    (value, index, self) => self.findIndex((t) => t.Initiative === value.Initiative) === index
  );
  const _initiaitveList5: LabelValue[] = _initiaitveList4.map((item) => ({ label: item.Initiative ?? '', value: item.Initiative ?? '' }));

  const _initiaitveList: LabelValue[] = items
    .map((item) => item.Initiative as string)
    .filter((value, index, self) => self.indexOf(value) === index)
    .map((item) => ({ label: item, value: item }));
  setInitiativeList(_initiaitveList5);
  return { _assigneeList, _initiaitveList };
}

export function createAssigneeList(tickets: Ticket[]): LabelValue[] {
  const assignees = tickets
    .map((ticket) => ticket.assignee)
    .filter((assignee, index, self) => self.indexOf(assignee) === index)
    .filter((assignee) => assignee && assignee !== tConst.ADO_UNASSIGNED)
    .sort((a, b) => a.localeCompare(b))
    .map((assignee) => ({ label: assignee, value: assignee }));
  
  return [
    { label: tConst.ADO_UNASSIGNED, value: tConst.ADO_UNASSIGNED },
    ...assignees
  ];
}

export default prepareTicket;
